export default {
  DEF_REDUCTION_POSTAGE_ITEM: {
    id: '',
    name: '',
    amount: undefined,
    type: null,
    goodsFlag: 0,
    activeTimeRanger: [],
    postageInstructions: '',
    status: null,
    activityLevelList: [],
    placeType: 0,
    picType: 1,
    picUrl: '',
    shortType: 1,
  },
  POSTAGE_SHORT_TYPE_LIST: [
    {
      label: '满减邮',
      value: 1,
    },
    {
      label: '满包邮 ',
      value: 2,
    },
  ],
  POSTAGE_SHORT_TYPE_ENUM: {
    freeShipping: 1,
    reducePostage: 2,
  },
  DEF_ACTIVE_LEVEL_ITEM: {
    id: '',
    _frontId: utils.genId(),
    conditionAmout: undefined,
    conditionPiece: undefined,
    postageCouponAmout: undefined,
    postageCouponRegionSaveDtos: [],
    postageCouponStatus: 1,
    level: undefined,
    type: undefined,
  },
  REDUCTION_POSTAGE_TYPE_ENUM: {
    price: 1,
    unit: 2,
  },
  REDUCTION_POSTAGE_TYPE_LIST: [
    {
      label: '满X元',
      value: 1,
    },
    {
      label: '满X件',
      value: 2,
    },
  ],
  // 活动状态，1：未开始，2：进行中，3：已结束 枚举类PostageStatusEnum
  REDUCTION_POSTAGE_STATUS_ENUM: {
    notStarted: 1,
    doing: 2,
    end: 3,
  },
  REDUCTION_POSTAGE_STATUS_LIST: [
    {
      label: '全部状态',
      value: '',
    },
    {
      label: '未开始',
      value: 1,
    },
    {
      label: '进行中',
      value: 2,
    },
    {
      label: '已结束',
      value: 3,
    },
  ],
  POSTAGE_COUPON_STATUS_ENUM: {
    freeShipping: 1,
    reducePostage: 2,
  },
  POSTAGE_COUPON_STATUS_LIST: [
    {
      label: '包邮',
      value: 1,
    },
    {
      label: '减邮费',
      value: 2,
    },
  ],
  POSTAGE_APPLY_TYPE_NAME: {
    all: 0,
    joinGoods: 1,
    notJoinGoods: 2,
  },
  POSTAGE_APPLY_TYPE_LIST: [
    {
      label: '全部商品',
      value: 0,
    },
    {
      label: '指定商品参与',
      value: 1,
    },
    {
      label: '指定商品不参与',
      value: 2,
    },
  ],
  POSTAGE_PLACE_TYPE_LIST: [
    {
      label: '优惠券',
      value: 1,
    },
  ],
  POSTAGE_PIC_TYPE_LIST: [
    {
      label: '系统默认',
      value: 1,
    },
    {
      label: '自定义',
      value: 2,
    },
  ],
  POSTAGE_PIC_TYPE_ENUM: {
    default: 1,
    custom: 2,
  },
};
